import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NigeriaGeneralAttendanceRegisterQueryVariables = Types.Exact<{
  input: Types.NigeriaGeneralAttendanceRegisterInput;
}>;


export type NigeriaGeneralAttendanceRegisterQuery = { readonly __typename?: 'Query', readonly nigeriaGeneralAttendanceRegister: { readonly __typename?: 'PaginatedNigeriaGeneralAttendanceRegister', readonly limit?: number | null, readonly offset?: number | null, readonly total?: number | null, readonly records?: ReadonlyArray<{ readonly __typename?: 'NigeriaGeneralAttendanceRegisterRecord', readonly id: string, readonly date: string, readonly patient: { readonly __typename?: 'PatientRegisterDetails', readonly patientUuid?: string | null, readonly name?: string | null, readonly dateOfBirth?: string | null, readonly gender?: Types.Gender | null, readonly cardId?: string | null, readonly firstContact?: boolean | null, readonly nextOfKinName?: string | null, readonly nextOfKinPhoneNumber?: string | null, readonly nextOfKinRelationship?: string | null, readonly phoneNumber?: { readonly __typename?: 'PatientDetailsPhoneNumber', readonly value?: string | null } | null, readonly address?: { readonly __typename?: 'Address', readonly street?: string | null, readonly ward?: string | null, readonly subCounty?: string | null, readonly state?: string | null, readonly country?: string | null } | null, readonly nextOfKinAddress?: { readonly __typename?: 'Address', readonly street?: string | null, readonly ward?: string | null, readonly subCounty?: string | null, readonly state?: string | null, readonly country?: string | null } | null } } | null> | null } };


export const NigeriaGeneralAttendanceRegisterDocument = gql`
    query NigeriaGeneralAttendanceRegister($input: NigeriaGeneralAttendanceRegisterInput!) {
  nigeriaGeneralAttendanceRegister(input: $input) {
    limit
    offset
    total
    records {
      id
      date
      patient {
        patientUuid
        name
        dateOfBirth
        gender
        cardId
        phoneNumber {
          value
        }
        address {
          street
          ward
          subCounty
          state
          country
        }
        firstContact
        nextOfKinName
        nextOfKinAddress {
          street
          ward
          subCounty
          state
          country
        }
        nextOfKinPhoneNumber
        nextOfKinRelationship
      }
    }
  }
}
    `;

/**
 * __useNigeriaGeneralAttendanceRegisterQuery__
 *
 * To run a query within a React component, call `useNigeriaGeneralAttendanceRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useNigeriaGeneralAttendanceRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNigeriaGeneralAttendanceRegisterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNigeriaGeneralAttendanceRegisterQuery(baseOptions: Apollo.QueryHookOptions<NigeriaGeneralAttendanceRegisterQuery, NigeriaGeneralAttendanceRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NigeriaGeneralAttendanceRegisterQuery, NigeriaGeneralAttendanceRegisterQueryVariables>(NigeriaGeneralAttendanceRegisterDocument, options);
      }
export function useNigeriaGeneralAttendanceRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NigeriaGeneralAttendanceRegisterQuery, NigeriaGeneralAttendanceRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NigeriaGeneralAttendanceRegisterQuery, NigeriaGeneralAttendanceRegisterQueryVariables>(NigeriaGeneralAttendanceRegisterDocument, options);
        }
export type NigeriaGeneralAttendanceRegisterQueryHookResult = ReturnType<typeof useNigeriaGeneralAttendanceRegisterQuery>;
export type NigeriaGeneralAttendanceRegisterLazyQueryHookResult = ReturnType<typeof useNigeriaGeneralAttendanceRegisterLazyQuery>;
export type NigeriaGeneralAttendanceRegisterQueryResult = Apollo.QueryResult<NigeriaGeneralAttendanceRegisterQuery, NigeriaGeneralAttendanceRegisterQueryVariables>;